import React from 'react';

/**
 * RenameVersionModal — extracted from RFPAnalysisResult.jsx (Phase 1 refactor).
 * Zero logic changes. All state/handlers passed as props from parent.
 */
const RenameVersionModal = ({ show, onClose, versionLabelText, setVersionLabelText, handleRenameVersion }) => {
    if (!show) return null;

    return (
        <div className="custom-modal-overlay">
            <div className="stage-modal-content" style={{ maxWidth: '400px' }}>
                <div className="stage-modal-header">
                    <h3>Rename Version</h3>
                    <p>Enter a new label for this version.</p>
                </div>
                <div className="stage-modal-body">
                    <input
                        type="text"
                        className="stage-modal-notes"
                        value={versionLabelText}
                        onChange={(e) => setVersionLabelText(e.target.value)}
                        placeholder="e.g. Final Draft, Initial Analysis"
                        autoFocus
                    />
                </div>
                <div className="stage-modal-actions">
                    <button className="stage-modal-cancel" onClick={onClose}>Cancel</button>
                    <button className="stage-modal-confirm accept-color" onClick={handleRenameVersion}>Save Label</button>
                </div>
            </div>
        </div>
    );
};

export default RenameVersionModal;
